import { httpClient } from '@shared/js/api/httpClient';

export const getShortLinkForMoment = async(eventVideoCropId) => {
	try {
		const response = await httpClient.getShortlink(eventVideoCropId);
		return response.data.url;
	} catch (e) {
		console.error('Unable to get shortlink: ' + e);
	}
	return null;
};
